import React from 'react';
import Redesign from './Redesign/Redesign';

function App() {
  return <Redesign />;
}

export default App;
